// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_io-6";
export var emphasizeQuantity = "_io-3";
export var flatBottomCorners = "_io-5";
export var productImage = "_io-0";
export var quantityContainer = "_io-2";
export var tooltip = "_io-1";
export var wrapAndEllipsesOverflow = "_io-4";